module.exports = __webpack_public_path__ + "static/media/geb.31e2f184.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/geb.svg
// module id = 527
// module chunks = 0